import styled from 'styled-components'

export const StyledIcon = styled.svg`
  fill: var(--secondaryBackground);
`
